import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

const selectAiTranslationState = (state: RootState) => state.aiTranslation;

export const selectAiLoading = createSelector(
  [selectAiTranslationState],
  (s) => s.loading
);

export const selectAiResult = createSelector(
  [selectAiTranslationState],
  (s) => s.result
);

export const selectAiError = createSelector(
  [selectAiTranslationState],
  (s) => s.error
);

export const selectHasTranslated = createSelector(
  [selectAiTranslationState],
  (s) => s.hasTranslated
);

export const selectReactivateLoading = createSelector(
  [selectAiTranslationState],
  (s) => s.reactivateLoading
);

export const selectReactivateResult = createSelector(
  [selectAiTranslationState],
  (s) => s.reactivateResult
);

export const selectReactivateError = createSelector(
  [selectAiTranslationState],
  (s) => s.reactivateError
);
